import React from 'react';
import { H2, P, UL, LI, FeatureLink } from './_shared';

export default {
  slug: 'integrations-overview',
  title: 'Integrations overview',
  category: 'integrations',
  summary: 'Connect lead sources, e-sign providers, calendars, MLS, SMS, and your own automations.',
  searchTerms: ['integrations', 'connect', 'zapier', 'mls', 'sms', 'calendar', 'idx'],
  related: ['api-keys', 'webhooks', 'public-api'],
  Body: () => (
    <>
      <P>
        <FeatureLink to="/settings/integrations">Integrations Hub</FeatureLink>{' '}
        is the one-stop console for everything that connects RealtyFlows to
        the outside world.
      </P>

      <H2>What you can connect today</H2>
      <UL>
        <LI><strong>Lead sources</strong> — Zillow, Realtor.com, Facebook Lead Ads, website form widget.</LI>
        <LI><strong>E-signature</strong> — DocuSign (default), Inkless.</LI>
        <LI><strong>Calendars</strong> — Google Calendar, Outlook (two-way sync).</LI>
        <LI><strong>MLS</strong> — pluggable; mock provider in dev, regional MLS connections in prod.</LI>
        <LI><strong>SMS</strong> — Twilio (default).</LI>
        <LI><strong>Webhooks + REST API</strong> — for everything else.</LI>
      </UL>

      <H2>Per-tenant credentials</H2>
      <P>
        Connections are scoped to your account (or team workspace). API keys
        and OAuth tokens are encrypted at rest and never shown after
        creation — store them in your password manager if you'll need them
        again.
      </P>
    </>
  ),
};
